// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  padding-left: 15px;
}
@media (max-width: 991px) {
  label {
    font-size: 14px;
  }
}

.userDataForm_input_wrap__EDpeu {
  width: 100%;
  max-width: 400px;
  position: relative;
  margin: 0 auto;
  margin-bottom: 20px;
}
.userDataForm_input_wrap__EDpeu input {
  height: 40px;
  width: 100%;
  padding: 10px 15px;
  padding-right: 25px;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 18px;
  line-height: 1;
}
.userDataForm_input_wrap__EDpeu button {
  position: absolute;
  bottom: 0;
  transform: translateY(-12%);
  right: 5px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 30px;
  padding: 0;
  color: var(--border-default-color);
}
.userDataForm_input_wrap__EDpeu button:hover {
  color: #a3a4a8;
}
.userDataForm_input_wrap__EDpeu .userDataForm_eye_button__cSV-X {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0px 8px;
  position: absolute;
  right: 1px;
  top: 6px;
  background: transparent;
  height: 38px;
}
.userDataForm_input_wrap__EDpeu .userDataForm_eye_button__cSV-X img {
  width: 20px;
  height: 20px;
}

.userDataForm_checkbox_wrap__ilENH {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  padding-left: 35px;
}
.userDataForm_checkbox_wrap__ilENH label {
  padding: 0;
}
.userDataForm_checkbox_wrap__ilENH input[type=checkbox] {
  width: 20px;
  position: absolute;
  left: 0;
  top: 0;
  accent-color: var(--primary-color);
}

.userDataForm_select_wrap__LLfrs {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0 auto;
  margin-bottom: 20px;
}
.userDataForm_select_wrap__LLfrs select {
  height: 40px;
  width: 100%;
  padding: 10px 18px;
  padding-right: 25px;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 18px;
  line-height: 1;
}

.userDataForm_input_file_wrap__I--vf {
  display: flex;
  flex-direction: column;
  max-width: 400px;
  margin: 0 auto;
}
.userDataForm_input_file_wrap__I--vf input[type=file] {
  position: relative;
  width: 100%;
  height: 50px;
  padding: 13px 15px;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  background-color: #ffffff;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}
.userDataForm_input_file_wrap__I--vf input[type=file]::file-selector-button {
  position: absolute;
  right: -5px;
  top: 0px;
  border: none;
  background: #b0b3ba;
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  min-width: fit-content;
  padding: 15px 20px;
  height: 100%;
  text-transform: uppercase;
  color: #000000;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.userDataForm_input_file_wrap__I--vf input[type=file]::file-selector-button:hover {
  background: var(--gray-text-color);
}

.userDataForm_form_input_error__SSZev {
  border: 1px solid red !important;
}
.userDataForm_form_input_error__SSZev::placeholder {
  color: red;
}

.userDataForm_error_message__UgsHS {
  color: red;
  font-size: 12px;
  line-height: 1;
}

.userDataForm_buttom_wrap__POC\\+o {
  display: flex;
  justify-content: space-between;
}
.userDataForm_buttom_wrap__POC\\+o .userDataForm_form_button__6XkML {
  display: block;
  margin: 0 auto;
  min-width: 270px;
  border-radius: 12px;
  padding: 15px 20px;
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: #ffffff;
  transition: all 0.3s;
  cursor: pointer;
}
.userDataForm_buttom_wrap__POC\\+o .userDataForm_form_button__6XkML:hover {
  background: var(--secondary-color-hover);
  border: 2px solid var(--secondary-color-hover);
  transition: all 0.3s;
}
.userDataForm_buttom_wrap__POC\\+o .userDataForm_form_button__6XkML:active {
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  transform: scale(0.98);
  transition: all 0.3s;
}
.userDataForm_buttom_wrap__POC\\+o .userDataForm_disabled__bwinH {
  background-color: #d3d3d3 !important;
  border: 2px solid #d3d3d3 !important;
  color: #ffffff;
  cursor: not-allowed;
}
.userDataForm_buttom_wrap__POC\\+o .userDataForm_form_button_save__ClLZr {
  background-color: var(--green-light);
  border: 2px solid var(--green-light);
  color: #2e706c;
}
.userDataForm_buttom_wrap__POC\\+o .userDataForm_form_button_save__ClLZr:hover {
  background: var(--primary-color);
  border: 2px solid var(--primary-color);
  color: #ffffff;
  transition: all 0.3s;
}
.userDataForm_buttom_wrap__POC\\+o .userDataForm_form_button_save__ClLZr:active {
  transform: scale(0.98);
  transition: all 0.3s;
}
.userDataForm_buttom_wrap__POC\\+o .userDataForm_form_button_save__ClLZr:disabled {
  background-color: #d3d3d3 !important;
  border: 2px solid #d3d3d3 !important;
  color: #ffffff;
  cursor: not-allowed;
}

@media (max-width: 1199px) {
  .userDataForm_input_wrap__EDpeu input {
    padding: 10px;
    padding-right: 20px;
    font-size: 16px;
  }
  .userDataForm_input_wrap__EDpeu input::placeholder {
    font-size: 16px;
  }
  .userDataForm_select_wrap__LLfrs select {
    padding: 10px;
    padding-right: 20px;
    font-size: 16px;
  }
  .userDataForm_input_file_wrap__I--vf input[type=file] {
    height: 45px;
    padding: 10px;
    font-size: 16px;
    line-height: 22px;
  }
  .userDataForm_input_file_wrap__I--vf input[type=file]::file-selector-button {
    padding: 10px 15px;
    font-size: 12px;
    line-height: 1;
  }
  .userDataForm_buttom_wrap__POC\\+o .userDataForm_form_button__6XkML {
    min-width: 200px;
    padding: 10px;
    font-size: 12px;
  }
}
@media (max-width: 991px) {
  .userDataForm_input_wrap__EDpeu input {
    font-size: 16px;
  }
  .userDataForm_input_wrap__EDpeu input::placeholder {
    font-size: 14px;
  }
  .userDataForm_input_file_wrap__I--vf input[type=file] {
    height: 40px;
    font-size: 14px;
  }
  .userDataForm_input_file_wrap__I--vf input[type=file]::file-selector-button {
    padding: 10px 15px;
    font-size: 12px;
    line-height: 1;
  }
  .userDataForm_buttom_wrap__POC\\+o .userDataForm_form_button__6XkML {
    padding: 8px 15px;
  }
}
@media (max-width: 800px) {
  .userDataForm_input_wrap__EDpeu button {
    font-size: 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Forms/UserDataForm/userDataForm.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EAHF;IAII,eAAA;EAEF;AACF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAEF;AAAE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAEJ;AACE;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,kCAAA;AACJ;AACI;EACE,cAAA;AACN;AAGE;EACE,6BAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;AADJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;;AAMA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAHF;AAKE;EACE,UAAA;AAHJ;AAME;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,kCAAA;AAJJ;;AAOA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAJF;AAME;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAJJ;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AALF;AAOE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gCAAA;AALJ;AAQE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;AANJ;AASE;EACE,kCAAA;AAPJ;;AAWA;EACE,gCAAA;AARF;AAUE;EACE,UAAA;AARJ;;AAYA;EACE,UAAA;EACA,eAAA;EACA,cAAA;AATF;;AAYA;EACE,aAAA;EACA,8BAAA;AATF;AAWE;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;EACA,wCAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;AATJ;AAWI;EACE,wCAAA;EACA,8CAAA;EAEA,oBAAA;AAVN;AAaI;EACE,wCAAA;EACA,wCAAA;EACA,sBAAA;EACA,oBAAA;AAXN;AAeE;EACE,oCAAA;EACA,oCAAA;EACA,cAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,oCAAA;EACA,oCAAA;EACA,cAAA;AAdJ;AAgBI;EACE,gCAAA;EACA,sCAAA;EACA,cAAA;EACA,oBAAA;AAdN;AAiBI;EACE,sBAAA;EACA,oBAAA;AAfN;AAkBI;EACE,oCAAA;EACA,oCAAA;EACA,cAAA;EACA,mBAAA;AAhBN;;AAqBA;EAEI;IACE,aAAA;IACA,mBAAA;IACA,eAAA;EAnBJ;EAqBI;IACE,eAAA;EAnBN;EAyBE;IACE,aAAA;IACA,mBAAA;IACA,eAAA;EAvBJ;EA4BE;IACE,YAAA;IACA,aAAA;IACA,eAAA;IACA,iBAAA;EA1BJ;EA6BE;IACE,kBAAA;IACA,eAAA;IACA,cAAA;EA3BJ;EAgCE;IACE,gBAAA;IACA,aAAA;IACA,eAAA;EA9BJ;AACF;AAkCA;EAEI;IACE,eAAA;EAjCJ;EAkCI;IACE,eAAA;EAhCN;EAsCE;IACE,YAAA;IACA,eAAA;EApCJ;EAuCE;IACE,kBAAA;IACA,eAAA;IACA,cAAA;EArCJ;EA0CE;IACE,iBAAA;EAxCJ;AACF;AA4CA;EAEI;IACE,eAAA;EA3CJ;AACF","sourcesContent":["label {\n  padding-left: 15px;\n\n  @media (max-width: 991px) {\n    font-size: 14px;\n  }\n}\n\n.input_wrap {\n  width: 100%;\n  max-width: 400px;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 20px;\n\n  input {\n    height: 40px;\n    width: 100%;\n    padding: 10px 15px;\n    padding-right: 25px;\n    border: none;\n    outline: none;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 1;\n  }\n\n  button {\n    position: absolute;\n    bottom: 0;\n    transform: translateY(-12%);\n    right: 5px;\n    border: none;\n    background: none;\n    cursor: pointer;\n    font-size: 30px;\n    padding: 0;\n    color: var(--border-default-color);\n\n    &:hover {\n      color: #a3a4a8;\n    }\n  }\n\n  .eye_button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 0px 8px;\n    position: absolute;\n    right: 1px;\n    top: 6px;\n    background: transparent;\n    height: 38px;\n\n    img {\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n.checkbox_wrap {\n  font-size: 14px;\n  display: flex;\n  flex-direction: column;\n  padding-left: 35px;\n\n  label {\n    padding: 0;\n  }\n\n  input[type=\"checkbox\"] {\n    width: 20px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    accent-color: var(--primary-color);\n  }\n}\n.select_wrap {\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 20px;\n\n  select {\n    height: 40px;\n    width: 100%;\n    padding: 10px 18px;\n    padding-right: 25px;\n    border: none;\n    outline: none;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 1;\n  }\n}\n\n.input_file_wrap {\n  display: flex;\n  flex-direction: column;\n  max-width: 400px;\n  margin: 0 auto;\n\n  input[type=\"file\"] {\n    position: relative;\n    width: 100%;\n    height: 50px;\n    padding: 13px 15px;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 24px;\n    background-color: #ffffff;\n    border-top-right-radius: 12px;\n    border-bottom-right-radius: 12px;\n  }\n\n  input[type=\"file\"]::file-selector-button {\n    position: absolute;\n    right: -5px;\n    top: 0px;\n    border: none;\n    background: #b0b3ba;\n    border-radius: 12px;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 16px;\n    min-width: fit-content;\n    padding: 15px 20px;\n    height: 100%;\n    text-transform: uppercase;\n    color: #000000;\n    cursor: pointer;\n    transition: background 0.2s ease-in-out;\n  }\n\n  input[type=\"file\"]::file-selector-button:hover {\n    background: var(--gray-text-color);\n  }\n}\n\n.form_input_error {\n  border: 1px solid red !important;\n\n  &::placeholder {\n    color: red;\n  }\n}\n\n.error_message {\n  color: red;\n  font-size: 12px;\n  line-height: 1;\n}\n\n.buttom_wrap {\n  display: flex;\n  justify-content: space-between;\n\n  .form_button {\n    display: block;\n    margin: 0 auto;\n    min-width: 270px;\n    border-radius: 12px;\n    padding: 15px 20px;\n    background-color: var(--secondary-color);\n    border: 2px solid var(--secondary-color);\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 16px;\n    color: #ffffff;\n    transition: all 0.3s;\n    cursor: pointer;\n\n    &:hover {\n      background: var(--secondary-color-hover);\n      border: 2px solid var(--secondary-color-hover);\n\n      transition: all 0.3s;\n    }\n\n    &:active {\n      background-color: var(--secondary-color);\n      border: 2px solid var(--secondary-color);\n      transform: scale(0.98);\n      transition: all 0.3s;\n    }\n  }\n\n  .disabled {\n    background-color: #d3d3d3 !important;\n    border: 2px solid #d3d3d3 !important;\n    color: #ffffff;\n    cursor: not-allowed;\n  }\n\n  .form_button_save {\n    background-color: var(--green-light);\n    border: 2px solid var(--green-light);\n    color: #2e706c;\n\n    &:hover {\n      background: var(--primary-color);\n      border: 2px solid var(--primary-color);\n      color: #ffffff;\n      transition: all 0.3s;\n    }\n\n    &:active {\n      transform: scale(0.98);\n      transition: all 0.3s;\n    }\n\n    &:disabled {\n      background-color: #d3d3d3 !important;\n      border: 2px solid #d3d3d3 !important;\n      color: #ffffff;\n      cursor: not-allowed;\n    }\n  }\n}\n\n@media (max-width: 1199px) {\n  .input_wrap {\n    input {\n      padding: 10px;\n      padding-right: 20px;\n      font-size: 16px;\n\n      &::placeholder {\n        font-size: 16px;\n      }\n    }\n  }\n\n  .select_wrap {\n    select {\n      padding: 10px;\n      padding-right: 20px;\n      font-size: 16px;\n    }\n  }\n\n  .input_file_wrap {\n    input[type=\"file\"] {\n      height: 45px;\n      padding: 10px;\n      font-size: 16px;\n      line-height: 22px;\n    }\n\n    input[type=\"file\"]::file-selector-button {\n      padding: 10px 15px;\n      font-size: 12px;\n      line-height: 1;\n    }\n  }\n\n  .buttom_wrap {\n    .form_button {\n      min-width: 200px;\n      padding: 10px;\n      font-size: 12px;\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .input_wrap {\n    input {\n      font-size: 16px;\n      &::placeholder {\n        font-size: 14px;\n      }\n    }\n  }\n\n  .input_file_wrap {\n    input[type=\"file\"] {\n      height: 40px;\n      font-size: 14px;\n    }\n\n    input[type=\"file\"]::file-selector-button {\n      padding: 10px 15px;\n      font-size: 12px;\n      line-height: 1;\n    }\n  }\n\n  .buttom_wrap {\n    .form_button {\n      padding: 8px 15px;\n    }\n  }\n}\n\n@media (max-width: 800px) {\n  .input_wrap {\n    button {\n      font-size: 25px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input_wrap": `userDataForm_input_wrap__EDpeu`,
	"eye_button": `userDataForm_eye_button__cSV-X`,
	"checkbox_wrap": `userDataForm_checkbox_wrap__ilENH`,
	"select_wrap": `userDataForm_select_wrap__LLfrs`,
	"input_file_wrap": `userDataForm_input_file_wrap__I--vf`,
	"form_input_error": `userDataForm_form_input_error__SSZev`,
	"error_message": `userDataForm_error_message__UgsHS`,
	"buttom_wrap": `userDataForm_buttom_wrap__POC+o`,
	"form_button": `userDataForm_form_button__6XkML`,
	"disabled": `userDataForm_disabled__bwinH`,
	"form_button_save": `userDataForm_form_button_save__ClLZr`
};
export default ___CSS_LOADER_EXPORT___;
